import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives/responsive";

import { Picture } from "@/components/wpl/image/src/image";
import { wacToken } from "@/libraries/design/foundations";

type JswDoubleFeatureCardProps = {
    readonly title: string;
    readonly description: string;
    readonly image: string;
};

export const JswDoubleFeatureCard = ({
    title,
    description,
    image
}: JswDoubleFeatureCardProps) => {
    return (
        <div css={cardStyle}>
            <div css={imageContainerStyle}>
                <Picture
                    image={{
                        src: image,
                        alt: ""
                    }}
                />
            </div>
            <div>
                <h3 css={titleStyles}>{title}</h3>
                <div css={descriptionStyles}>{description}</div>
            </div>
        </div>
    );
};

const cardStyle = css({
    display: "grid",
    width: "569px",
    gap: "23px",
    background: wacToken("color.neutral.light0"),
    boxShadow:
        // eslint-disable-next-line local/ensure-wac-token-usage
        "0px 1px 1px 0px rgba(9, 30, 66, 0.25), 0px 0px 1px 0px rgba(9, 30, 66, 0.31)",
    [media.below.lg]: {
        maxWidth: "569px",
        width: "100%"
    }
});

const titleStyles = css({
    color: wacToken("color.primary.black"),
    textAlign: "center",
    fontFamily: wacToken("font.charlie.display"),
    fontSize: "24px",
    fontWeight: "700",
    lineHeight: "30px",
    margin: 0
});

const descriptionStyles = css({
    color: wacToken("color.primary.black"),
    textAlign: "center",
    fontFamily: wacToken("font.charlie.text"),
    fontSize: "15px",
    fontWeight: "400",
    lineHeight: "23px",
    padding: "8px 100px 75px 100px",
    [media.below.lg]: {
        padding: "8px 25px 25px 25px"
    }
});

const imageContainerStyle = css({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    img: {
        width: "100%",
        height: "100%"
    }
});
